import ActionTypes from "../actionTypes";

const initialState = {
    isLoading: false,
    user: null,
    isLogin: false,
    userLoginGoogle: null
}

const UserReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.IS_LOADING:
            return {
            ...state,
            isLoading: action.value,
            };
        case ActionTypes.ISLOGIN:
            return {
            ...state,
            isLogin: action.value,
            };
        case ActionTypes.CHANGE_USER:
            return {
                ...state,
                user: action.type
            }
        case ActionTypes.CHANGE_USER_GOOGLE_LOGIN:
            return {
              ...state,
              userLoginGoogle: action.type
            };
        default:
            return state;
    }
}

export default UserReducer;


